// connect
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import persistReducer from 'redux-persist/es/persistReducer'
import { persistStore } from 'redux-persist'
import { setupListeners } from '@reduxjs/toolkit/query'

// slice
import authReducer from '@/shared/store/slice/authSlice'
import cartReducer from '@/shared/store/slice/cartSlice'
import productHistorySlice from '@/shared/store/slice/productHistorySlice'
import favoriteReducer from '@/shared/store/slice/favoriteSlice'
import categoryReducer from '@/shared/store/slice/categorySlice';
// api
import generalApi from '@/shared/api-rtk/api-list/generalApi'
import questionsApi from '@/shared/api-rtk/api-list/questionsApi.js'
import { chatApi } from '@/shared/api-rtk/api-list/chatApi.js'
import { authApi } from '@/shared/api-rtk/api-list/authApi.js'
import { profileApi } from '@/shared/api-rtk/api-list/profileApi.js'
import { newsApi } from '@/shared/api-rtk/api-list/newsApi'
import { blogApi } from '@/shared/api-rtk/api-list/blogApi.js'
import { productCatalogApi } from '@/shared/api-rtk/api-list/productCatalogApi.js'
import { ocApi } from '@/shared/api-rtk/api-list/ocApi'
import storage from 'redux-persist/lib/storage'
import localStorage from 'redux-persist/es/storage'

const rootReducer = combineReducers({
    authUser: authReducer,
    cartActions: cartReducer,
    favorite: favoriteReducer,
    productHistory: productHistorySlice,
    category: categoryReducer,
    [generalApi.reducerPath]: generalApi.reducer,
    [questionsApi.reducerPath]: questionsApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [newsApi.reducerPath]: newsApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [productCatalogApi.reducerPath]: productCatalogApi.reducer,
    [ocApi.reducerPath]: ocApi.reducer,
})

const persistConfig = {
    key: 'root',
    storage: {
        getItem: (key) => localStorage.getItem(key),
        setItem: (key, value) => localStorage.setItem(key, value),
        removeItem: (key) => localStorage.removeItem(key),
    },
    whitelist: ['authUser', 'cartActions', 'favorite', 'productHistory'],
}

export const makeConfigureStore = () =>
    configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }).concat(
                generalApi.middleware,
                questionsApi.middleware,
                chatApi.middleware,
                authApi.middleware,
                profileApi.middleware,
                newsApi.middleware,
                blogApi.middleware,
                productCatalogApi.middleware,
                ocApi.middleware
            ),
    })

export const makeStore = () => {
    if (typeof window === 'undefined') return makeConfigureStore()
    else {
        const persistedReducer = persistReducer(persistConfig, rootReducer)

        let store = configureStore({
            reducer: persistedReducer,
            middleware: (getDefaultMiddleware) =>
                getDefaultMiddleware({
                    serializableCheck: false,
                }).concat(
                    generalApi.middleware,
                    questionsApi.middleware,
                    chatApi.middleware,
                    authApi.middleware,
                    profileApi.middleware,
                    newsApi.middleware,
                    blogApi.middleware,
                    productCatalogApi.middleware,
                    ocApi.middleware
                ),
        })

        store.__persistor = persistStore(store)
        setupListeners(store.dispatch)
        return store
    }
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            generalApi.middleware,
            questionsApi.middleware,
            chatApi.middleware,
            authApi.middleware,
            profileApi.middleware,
            newsApi.middleware,
            blogApi.middleware,
            productCatalogApi.middleware,
            ocApi.middleware
        ),
})

export const persist = persistStore(store)
setupListeners(store.dispatch)
